import { deprecatedColors } from 'foundations-theming-base/deprecated-colors';
import { safeLocalStorageGet } from './safeLocalStorage';
import { getCssVariablesTheme, getUseCssVariables } from './localCssVariables';
export const FLASH_TOKENS_STORAGE_KEY = 'trellis:flash-unsafe-tokens';
export const FLASH_CSS_VAR = '--trellis-flash-token';
export function shouldFlashTokens() {
  return safeLocalStorageGet(FLASH_TOKENS_STORAGE_KEY) === 'true';
}
function replaceTargetTokensWithCssVar(colorObj) {
  const result = {};
  for (const [key, value] of Object.entries(colorObj)) {
    result[key] = deprecatedColors.includes(key) ? `var(${FLASH_CSS_VAR})` : value;
  }
  return result;
}
export const mergeThemeWithOverrides = (baseTheme, overrides) => {
  return Object.assign({}, baseTheme, {
    color: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.color, overrides.color),
    space: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.space, overrides.space),
    borderRadius: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.borderRadius, overrides.borderRadius),
    borderWidth: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.borderWidth, overrides.borderWidth),
    boxShadow: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.boxShadow, overrides.boxShadow),
    typography: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.typography, overrides.typography)
  });
};
export function applyThemeOverrides(theme, themeOverrides) {
  if (themeOverrides && Object.keys(themeOverrides).length > 0) {
    theme = mergeThemeWithOverrides(theme, themeOverrides);
  }
  if (getUseCssVariables()) {
    theme = getCssVariablesTheme(theme);
  }

  // Apply flashing if enabled
  if (shouldFlashTokens()) {
    theme = Object.assign({}, theme, {
      color: replaceTargetTokensWithCssVar(theme.color)
    });
  }
  return theme;
}